import {
	getRawPermissions,
} from 'Vulture/Permissions.js';
import {
	broncoURL,
} from 'Vulture/ENV.js';
import BroncoSDK from 'Vulture/lib/BroncoSDK.js';

const broncoSDK = new BroncoSDK({
	baseURL: broncoURL,
});

// Resolve the logged-in user's identity for chat. Lifted from
// SalesforceChat.fetchUserName: the name lives on the crow_auth user record (the
// bronco app `user` table only has uuid + display_name) and is returned by the
// self-scoped permissions endpoint. That response is already fetched at login and
// cached in Permissions.js, so prefer the cache and only fall back to a fetch if
// the chat starts before permissions have loaded. Returns empty name strings on
// any failure so the email is still sent.
//
// Note (v1): identity here is CLIENT-ASSERTED — it rides an unauthenticated MIAW
// token as routing attributes, so it's advisory. The agent must not make trust
// decisions on it. Authenticated (bronco-signed JWT) identity is a phase-2 hardening.
export const resolveChatIdentity = async (session) => {
	const identity = {
		firstName: '',
		lastName: '',
		email: (session && session.email) || '',
	};

	if (!session) {
		return identity;
	}

	let data = getRawPermissions();

	if (!data) {
		try {
			broncoSDK.setAuth(session.session, session.user);
			data = await broncoSDK.getUserPermissions();
		} catch (err) {
			console.error('Error resolving chat identity:', err);
			return identity;
		}
	}

	identity.firstName = data.first_name || '';
	identity.lastName = data.last_name || '';
	return identity;
};

// Fetch a bronco-signed MIAW identity JWT for the current user (authenticated
// flow). Self-scoped endpoint; BroncoSDK.request adds the X-Auth-Session /
// X-User-UUID headers and throws on a non-2xx.
export const fetchSparkieIdentityToken = async (session) => {
	if (!session || !session.user) {
		throw new Error('no session for Sparkie identity token');
	}
	broncoSDK.setAuth(session.session, session.user);
	const data = await broncoSDK.request(`/user/${session.user}/sparkie-identity-token`, {
		method: 'GET',
	});
	return data.token;
};
